import { FC, useEffect, useState } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Grid, TextField, Button } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { SCUICustomDataGrid, SCUIMPConfigDialog } from '../../atomic/molecules';
import { SCUIButton } from '../../atomic/atoms';
import Swal from 'sweetalert2';
import MobilePanelConfigurationQuery from '../../services/query/mobileAppConfiguration/MobileAppConfiguration.services';
import MobilePanelConfigurationCommand from '../../services/command/mobilepanelconfiguration/MobilePanelConfigurationCommand.services';
import { useTranslation } from 'react-i18next';

export const MpConfig: FC<any> = () => {
    const { t } = useTranslation();
    const [refresh, setRefresh] = useState(false);
    const [searchedMpConfigList, setSearchedMpConfigList] = useState<any>();
    const [openEditModal, setOpenEditModal] = useState(false);
    const [mpConfiguration, setMpConfiguration] = useState<any>();
    const [mobilepanelconfiguration, setMobilePanelConfiguration] = useState([]);
    const [searchedMpConfigName, setSearchedMpConfigName] = useState('');

    const refreshFunc = () => setRefresh((prevRefreshing) => !prevRefreshing);
    const onModalEditOpen = () => setOpenEditModal(true);
    const onModalEditClose = () => setOpenEditModal(false);

    const getMobilePanelConfiguration = () => {
        MobilePanelConfigurationQuery.ListMobileAppConfiguration()
            .then((res: any) => {
                if (res) {
                    let parseData = res.model.data.map((item: any) => {
                        return {
                            id: item.id || '-',
                            parameter_key: item.parameter_Key || ' ',
                            parameter_value: item.parameter_Value || ' ',
                        };
                    });

                    setMobilePanelConfiguration(parseData);
                    setSearchedMpConfigList(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };

    useEffect(() => {
        getMobilePanelConfiguration();
    }, [refresh]);

    const requestSearchMpConfig = (searchedVal: any) => {
        setSearchedMpConfigName(searchedVal.target.value);
        let filteredRoles = searchedMpConfigList.filter(
            (o: any) => o.parameter_key.toLowerCase().indexOf(searchedVal.target.value.toLowerCase()) !== -1
        );
        setMobilePanelConfiguration(filteredRoles);
    };

    const sil = async (params: any) => {
        const result = await Swal.fire({
            text: t('mobilePanel.deleteConfig'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.delete'),
        });

        if (!result.isConfirmed) {
            return;
        }

        try {
            await MobilePanelConfigurationCommand.PostRemoveMobilePanelConfiguration(params);
            Swal.fire('Silindi!', ' ', 'success');
            setRefresh((prevRefreshing) => !prevRefreshing);
        } catch (error: any) {
            console.log('Hata :>> ', error);
        }
    };

    const columns: ExtendedGridColDef[] = [
        { field: 'id', headerName: 'ID', width: 90, flex: 1, hide: true },
        {
            field: 'parameter_key',
            headerName: 'Key',
            width: 150,
            flex: 1,
        },
        {
            field: 'parameter_value',
            headerName: 'Value',
            width: 160,
            flex: 1,
        },
        {
            field: 'düzenlee',
            headerName: t('general.edit'),
            width: 160,
            headerAlign: 'center',
            flex: 1,
            align: 'center',
            renderCell: (params) => {
                const onclick = () => {
                    setMpConfiguration(params.row);
                    onModalEditOpen();
                };

                return (
                    <div>
                        <Button onClick={onclick}>
                            <EditIcon />
                        </Button>
                    </div>
                );
            },
        },

        {
            field: 'sil',
            headerName: t('general.delete'),
            width: 160,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const onclick = () => {
                    sil(params.id);
                };
                return (
                    <div>
                        <Button onClick={onclick}>
                            <DeleteIcon />
                        </Button>
                    </div>
                );
            },
        },
    ];

    return (
        <SCUIContent>
            <SCUIMPConfigDialog
                selectedRow={mpConfiguration}
                open={openEditModal}
                onClose={onModalEditClose}
                refresh={refreshFunc}
            />
            <Grid container direction="row">
                <Grid
                    size={{
                        lg: 10,
                        md: 6,
                        xs: 6,
                    }}
                >
                    <h1 className="headtxt">{t('mobilePanel.mobilePanelConfiguration')} </h1>
                </Grid>
                <Grid
                    size={{
                        lg: 2,
                        md: 6,
                        xs: 6,
                    }}
                >
                    <SCUIButton
                        text={t('mobilePanel.addConfig')}
                        type="primary"
                        sizeType="fixed"
                        size={'m'}
                        onClick={() => {
                            setMpConfiguration([]);
                            onModalEditOpen();
                        }}
                    />
                </Grid>

                <Grid
                    sx={{ marginBottom: 1, marginTop: 1 }}
                    size={{
                        xs: 12,
                        sm: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <TextField
                        label={'Key'}
                        value={searchedMpConfigName}
                        onChange={(searchVal) => requestSearchMpConfig(searchVal)}
                        fullWidth
                    />
                </Grid>

                <Grid
                    size={{
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <SCUICustomDataGrid
                        rows={mobilepanelconfiguration}
                        columns={columns}
                        initialState={{
                            sorting: {
                                sortModel: [
                                    {
                                        field: 'id',
                                        sort: 'asc',
                                    },
                                ],
                            },
                        }}
                    />
                </Grid>
            </Grid>
        </SCUIContent>
    );
};
